SEARCH_DISCLOSURE = {
    messages: {
        VOIR_PLUS: "Ver más",
        VOIR_MOINS: "Ver menos"
    }
};
